import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login";
import {getDataInLocalStorage, saveDataToLocalStorage} from "@/utils/localStorage";
import Home from "@/views/home/Home";
import OverView from "@/views/systems/OverView";
import Info from "@/views/systems/Info";
import Customer from "@/views/systems/Customer";
import Email from "@/views/systems/Email";
import Configuration from "@/views/systems/Configuration";
import RawDataProject from "@/views/systems/project/rawData/rawDataProject";
import MetagProject from "@/views/systems/project/metag/MetagProject";
import MetaboProject from "@/views/systems/project/metabo/MetaboProject";
import BZProject from "@/views/systems/project/bz/BZProject";
import SystemCondition from "@/views/systems/condition/SystemCondition";
import {flushLogin, logout} from "@/api/dilivery";
import store from "@/store";
import ApproveIndex from "@/views/systems/report/ApproveIndex";
import ApproveReport from "@/views/systems/report/ApproveReport";
import Test from "@/test/Test";
import NakedIndex from "@/views/systems/naked/NakedIndex";
import NakedRawData from "@/views/systems/naked/NakedRawData";
import NakedUser from "@/views/systems/naked/NakedUser";
import NakedApproval from "@/views/systems/naked/NakedApproval";
import TransProject from "@/views/systems/project/trans/TransProject";
import ApproveReportUser from "@/views/systems/report/ApproveReportUser";
import PersonalPlan from "@/views/systems/PersonalPlan";
import Log from "@/views/systems/Log";
import Contact from "@/views/systems/Contact";
import {LENotFound, LEServerError} from 'w-design-ui'
import SingleCellProject from "@/views/systems/project/singleCell/SingleCellProject.vue";
import TransMetaboProject from "@/views/systems/project/transMetabo/TransMetaboProject.vue";
import BzMetaboProject from "@/views/systems/project/bzMetabo/BzMetaboProject.vue";
import EDNAProject from "@/views/systems/project/eDNA/EDNAProject.vue";
import BZFunProject from "@/views/systems/project/bzFun/BZFunProject.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        children: [{
            path: '/index',
            name: '项目信息总览',
            component: OverView
        },  {
            path: '/projectBz',
            name: '多样性交付系统',
            component: BZProject
        }, {
            path: '/projectBzFun',
            name: '功能基因扩增子交付系统',
            component: BZFunProject
        }, {
            path: '/projectMetag',
            name: '宏基因组交付系统',
            component: MetagProject
        }, {
            path: '/projectTrans',
            name: '转录组交付系统',
            component: TransProject
        }, {
            path: '/projectMetabo',
            name: '代谢交付系统',
            component: MetaboProject
        },{
            path: '/projectSingleCell',
            name: '单细胞交付系统',
            component: SingleCellProject
        }, {
            path: '/projectTransMetabo',
            name: '转录和代谢联合分析交付系统',
            component: TransMetaboProject
        },{
            path: '/projectBzMetabo',
            name: '多样性和代谢联合分析交付系统',
            component: BzMetaboProject
        }, {
            path: '/projectEDNA',
            name: '鱼类eDNA交付系统',
            component: EDNAProject
        }, {
            path: '/info',
            name: '个人中心',
            component: Info
        }, {
            path: '/customer',
            name: '客户管理',
            component: Customer
        }, {
            path: '/email',
            name: '邮件管理',
            component: Email
        }, {
            path: '/config',
            name: '系统配置',
            component: Configuration
        }, {
            path: '/personalPlan',
            name: '自定义绘图方案',
            component: PersonalPlan
        }, {
            path: '/systemCondition',
            name: '项目使用情况',
            component: SystemCondition
        }, {
            path: '/approve',
            name: '审批',
            component: ApproveIndex,
            children: [
                {
                    path: '/approveUser',
                    name: '审批/审批人员管理',
                    component: ApproveReportUser
                }, {
                    path: '/approveReport',
                    name: '报告审批管理',
                    component: ApproveReport
                }
            ]
        }, {
            path: '/naked',
            name: '裸测项目交付系统',
            component: NakedIndex,
            children: [
                {
                    path: '/nakedUser',
                    name: '裸测项目交付系统/审批人员管理',
                    component: NakedUser
                }, {
                    path: '/nakedApproval',
                    name: '裸测项目交付系统/审批管理',
                    component: NakedApproval
                }, {
                    path: '/nakedRawData',
                    name: '裸测项目交付系统/原始数据',
                    component: NakedRawData
                }
            ]
        },
            {
                path: '/projectRawData',
                name: '其他类型项目交付系统',
                component: RawDataProject
            },
            {
                path: '/log',
                name: '更新日志',
                component: Log,
                children: []
            },
            {
                path: '/contact',
                name: '',
                component: Contact,
                children: []
            },
        ],
    },
    {
        path: '/login',
        name: Login,
        component: Login
    }, {
        path: '/test',
        name: 'Test',
        component: Test
    },
    {
        path: '/error',
        name: 'LEServerError',
        component: LEServerError
    },
    // { path: '/:pathMatch(.*)*', name: 'LENotFound', component: LENotFound }
]
Vue.use(VueRouter)
const router = new VueRouter({
    routes,
    mode: 'history',
});
// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
// 路由全局前置守卫
router.beforeEach(async (to, from, next) => {
    // 在路由跳转前执行的逻辑
    let hasToken = getDataInLocalStorage('token')
    if (to.path === '/login') {
        const res = await logout()
        if (res.code === 200) {
            store.commit('right/setInit')
        }
        next()
    } else {
        if (to.query.isNeedRush) {
            store.commit('right/setInit')
            saveDataToLocalStorage("token", to.query.token)
            hasToken = to.query.token
            delete to.query.isNeedRush
            delete to.query.token
            const res = await flushLogin()
            if (res?.data?.code === 200) {
                let userInfo = {
                    ...res.data.data,
                    'approve_report_viewer': res.data.data.reviewer,
                    'approve_naked_viewer': res.data.data?.attribute?.nakedViewer
                }
                store.commit("right/setUser", userInfo)
                store.commit("right/setRole", res.data.data.role)
                store.commit("right/setToken", res.headers.authorization)
                const {token, isNeedRush, ...cleanQuery} = to.query
                next({path: to.path, query: cleanQuery, replace: true})
                return
            }
        }
        if (hasToken) {
            if (to.path !== "/" && to.path !== "/login") { //判断是否要跳到登录界面
                next();
            } else {
                next({
                    path: '/index'
                })
            }
        } else {
            if (to?.query) {
                if (to.query?.shareCode) {
                    localStorage.setItem('shareCode', to.query.shareCode)
                }
            }
            next('/login')
        }
    }
});
router.afterEach((to, from) => {
    // 在每次路由跳转完成后清空 Vuex 状态
    if (to.path === '/login') {
        store.commit('dataStatus/setInit');
    }

});
export default router
